import { api as apiProvider } from '@/core/api/';

const baseApiURL = 'api/providers/accountNumbers';

export const getAcademicYears = async () =>
  apiProvider.get(`${baseApiURL}/academicYears`);
export const searchPurchaseOrders = (payload) =>
  apiProvider.get(`${baseApiURL}/results`, { params: payload });

export const savePurchaseOrders = async (payload) =>
  apiProvider.post(`${baseApiURL}/save`, payload);

export const updateProjectFound = async (payload) =>
  apiProvider.post(`${baseApiURL}/updateprojectfound`, payload);

export const getBillingServiceCategories = async () =>
  apiProvider.get(`${baseApiURL}/billingservicecategories`);

export const getServiceCenters = async () =>
  apiProvider.get(`${baseApiURL}/servicecenters`);

export const getFundsUse = async (purchaseOrderNumberId) => {
  return await apiProvider.get(
    `${baseApiURL}/fundsuse/${purchaseOrderNumberId}`
  );
};
